<template>
    <div class="container">
        <div class="container-nav">
            <img src="../assets/images/laidan_logo.png" alt="">
        </div>
        <div class="container-main">
            <!-- 中奖奖品 -->
            <div class="winning" v-if="winningList.length > 0">
                <div class="shell">
                    <div class="list">
                        <div class="card" v-for="(item, index) in winningList" :key="item.id">
                            <div class="card-header">
                                <p class="name">{{ item.shopName }}</p>
                                <p class="name">{{ item.activityAwardsName }}:&nbsp;{{ item.awardName }}</p>
                                <p class="hint" v-if="item.receive">{{ $t('haveUsed') }}</p>
                                <template v-else>
                                    <p class="date">{{ $t('validTime') }}&nbsp;{{ item.awardInvalidAt }}</p>
                                    <p class="hint">{{ $t('useAwaCodeHint') }}</p>
                                </template>
                            </div>
                            <div class="qrcode">
                                <img :id="'lottery_win' + index">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 平台抽奖码 -->
            <div class="code" v-if="codeList.length > 0">
                <h3 class="code-title">{{ $t('platLottoCode') }}</h3>
                <div class="shell">
                    <div class="list">
                        <div class="card" v-for="item in codeList" :key="item.id">
                            <p class="title">{{ $t('lottoCode') }}{{ item.code }}</p>
                            <p class="text">{{ $t('lotteryTime') }}{{item.luckyDrawTime}}</p>
                            <div class="seal">
                                <p class="state" v-if="item.luckyDrawState === 101">{{ $t('noLottery') }}</p>
                                <p class="state" v-else-if="item.luckyDrawState === 102">{{ $t('noWinning') }}</p>
                                <p class="state" v-else-if="item.luckyDrawState === 103">{{ $t('yetWinning') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 抽奖流程 -->
            <div class="flow">
                <div class="card">
                    <iframe :src="flowVideoUrl"
                            width="100%"
                            height="100%"
                            scrolling="no"
                            allowfullscreen="true"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            frameborder="0">
                    </iframe>
                </div>
            </div>
            <!-- 奖品 -->
            <div class="awards" v-if="awardsList.length > 0">
                <h3 class="awards-title">{{ $t('prize') }}</h3>
                <van-swipe class="my-swipe"
                           :autoplay="3000"
                           indicator-color="white">
                    <van-swipe-item v-for="item in awardsList"
                                    :key="item.id">
                        <div class="card">
                            <div class="play-item"
                                 :style="getPlayItemStyle(inItem)"
                                 v-for="inItem in item.programItems"
                                 :key="inItem.id">
                                <template v-if="inItem.resourceFileType === 101">
                                    <img :src="inItem.resourceFileUrl"
                                         style="width: 100%; height: 100%; object-fit: cover;"
                                         alt="">
                                </template>
                                <template v-else-if="inItem.resourceFileType === 102">
                                    <video :src="inItem.resourceFileUrl"
                                           :muted="inItem.muted"
                                           autoplay="false"
                                           webkit-playsinline="true"
                                           playsinline="true"
                                           style="width: 100%; height: 100%; object-fit: cover;"></video>
                                </template>
                            </div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <!-- 介绍 -->
            <div class="intro">
                <h3 class="intro-title">{{ $t('introTitle') }}</h3>
                <div class="card">
                    <div class="list">
                        <div class="video">
                            <iframe :src="introVideoUrl1"
                                    width="100%"
                                    height="100%"
                                    scrolling="no"
                                    allowfullscreen="true"
                                    webkitallowfullscreen="true"
                                    mozallowfullscreen="true"
                                    frameborder="0">
                            </iframe>
                        </div>
                        <div class="video">
                            <iframe :src="introVideoUrl2"
                                    width="100%"
                                    height="100%"
                                    scrolling="no"
                                    allowfullscreen="true"
                                    webkitallowfullscreen="true"
                                    mozallowfullscreen="true"
                                    frameborder="0">
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 规则 -->
            <div class="rule">
                <h3 class="rule-title"
                    @click="ruleShow = true">
                    {{ $t('lotteryRule') }}
                    <i v-show="!ruleShow">{{ $t('checkDetailsHint') }}</i>
                </h3>
                <div class="rule-content" v-show="ruleShow">
                    <h3 class="rule-title">REGOLAMENTO CONCORSO A PREMI LAIDAN</h3>
                    <div class="rule-list">
                        <div class="list-item">
                            <p class="item-text">
                                <span class="label">TIPOLOGIA:</span>
                                Concorso a premi con attribuzione delle vincite attraverso estrazione Bisettimanale effettuata da software.
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-text">
                                <span class="label">DENOMINAZIONE:</span>
                                "Laidan ti premia"
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-text">
                                <span class="label">DURATA:</span>
                                ciclo continuo a cadenza Bimestrale (due volte al mese)
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-text">
                                <span class="label">TERRITORIO:</span>
                                Territorio Nazionale
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-text">
                                <span class="label">DESTINATARI:</span>
                                Clienti dei ristoranti aderenti al concorso che utilizzano il gestionale POINTS ME e che hanno aderito all’iniziativa,
                                genererà dei codici in fase di pagamento con i quali partecipare al concorso. La lista completa dei ristoranti aderenti
                                sul sito laidan.it nella sezione concorso a premi/ristorantiaderenti
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-title">MECCANICA</p>
                            <p class="item-text">
                                Nel periodo dell’iniziativa i clienti dei ristoranti che utilizzano il gestionale POINTS ME (Vedi lista al link sopra citato) parteciperanno alla maxi estrazione.
                            </p>
                            <p class="item-text">
                                Al pagamento di ogni pasto i partecipanti acquistano automaticamente il diritto a partecipare nella misura di una volta per scontrino per
                                la vincita del maxi premio che sarà diverso di volta in volta e dei premi secondari.
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-title">MODALITA’ DI ESTRAZIONE</p>
                            <p class="item-text">
                                L’estrazione avverrà in diretta sui profili social Instagram e TikTok di Laidan.it
                                Gli estremi dell’acquisto (in particolare il codice univoco generato dal sistema POINTS ME), verranno inseriti in un database. Il software di estrazione è stato
                                predisposto in modo che venga individuato un codice vincitore e dei codici vincitori secondari fra i codici presenti nel database per il concorso della giornata.
                            </p>
                            <p class="item-text">
                                Il software di estrazione è basato su un algoritmo che risulta perfettamente aleatorio e non violabile, il quale assegna ai partecipanti i premi in modo casuale.
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-text">
                                Modalità di estrazione per ogni giornata di estrazione:
                            </p>
                            <p class="item-text">
                                <span class="dot"></span>
                                Estrazione primo vincitore per premio di prima categoria
                            </p>
                            <p class="item-text">
                                <span class="dot"></span>
                                Estrazione secondo vincitore per premio di seconda categoria
                            </p>
                            <p class="item-text">
                                <span class="dot"></span>
                                Estrazione terzo vincitore per premio di terza categoria
                            </p>
                            <p class="item-text">
                                <span class="dot"></span>
                                Estrazione quarto vincitore per premio di quarta categoria
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-title">MODALITA’ DI CONSEGNA PREMI</p>
                            <p class="item-text">
                                I partecipanti risultati vincitori dovranno confermare la vincita attraverso l’applicazione laidan (scaricabile su tutti i dispositivi android e IOS) attraverso un
                                pulsante di conferma che apparirà sulla schermata nel momento della vincita e che rimarrà attivo per 3 minuti.
                            </p>
                            <p class="item-text">
                                Qualora il vincitore non confermerà i presentatori della diretta provvederanno a continuare le estrazioni e quindi a riassegnare il premio.
                            </p>
                            <p class="item-text">
                                I premi verranno spediti al vincitore tramite Poste Italiane entro e non oltre i 20 giorni dall’estrazione tramite raccomandata con ricevuta di ritorno.
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-title">NOTE FINALI</p>
                            <p class="item-text">
                                Il promotore non si assume responsabilità per qualsiasi problema di accesso, impedimento, disfunzione o difficoltà riguardanti gli strumenti tecnici,
                                la linea telefonica, il software e l’hardware, la trasmissione e la connessione, il collegamento internet che possono impedire al concorrente
                                di accedere ai portali dove si svolgerà l’estrazione.
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-text">
                                Il trattamento dei dati raccolti in occasione del presente concorso a premi verrà effettuato nel rispetto della normativa vigente in materia di privacy;
                                i dati dei vincitori verranno utilizzati ai soli fini dell’attribuzione dei premi.
                            </p>
                        </div>
                        <div class="list-item">
                            <p class="item-text">
                                Milano, 03/03/2023
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="download-handle">
            <button @click="downloadHandle1" v-if="lotteryCode">{{ $t('downloadApp') }}</button>
            <button @click="downloadHandle2" v-else>{{ $t('downloadApp') }}</button>
        </div>
    </div>
</template>

<script>

import {queryAwardsList, queryUserLottoCode, queryUserPrize} from "@/api";
import {mapState} from "vuex";
import JsBarcode from "jsbarcode";
export default {
    name: 'Lottery',
    // 组件
    components: {
    
    },
    props: {},
    data () {
        return {
            language: '',
            winningList: [],    // 中奖列表
            codeList: [],    // 抽奖码列表
            flowVideoUrl: '',   // 视频
            introVideoUrl1: '',  // 介绍视频1
            introVideoUrl2: '',  // 介绍视频2
            ruleShow: false,   // 显示规则详情
            awardsList: [],  // 奖品列表
        };
    },
    // 计算属性
    computed: {
        ...mapState(['pointsMeMerId', 'lotteryCode', 'activityId']),
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 初始化数据
        initData () {
            // 视频
            switch (this.language) {
                case 'zh':
                    this.flowVideoUrl = 'https://www.youtube.com/embed/Yz4-G4TYpHc'
                    this.introVideoUrl1 = 'https://www.youtube.com/embed/_rW4NL4YQgk'
                    this.introVideoUrl2 = 'https://www.youtube.com/embed/xYPNLEYpw-s'
                    break;
                case 'it':
                    this.flowVideoUrl = 'https://www.youtube.com/embed/Yz4-G4TYpHc'
                    this.introVideoUrl1 = 'https://www.youtube.com/embed/ItbC9pkvzXo'
                    this.introVideoUrl2 = 'https://www.youtube.com/embed/xYPNLEYpw-s'
                    break;
                case 'en':
                    this.flowVideoUrl = 'https://www.youtube.com/embed/Yz4-G4TYpHc'
                    this.introVideoUrl1 = 'https://www.youtube.com/embed/ItbC9pkvzXo'
                    this.introVideoUrl2 = 'https://www.youtube.com/embed/xYPNLEYpw-s'
                    break;
                default:
                    this.flowVideoUrl = 'https://www.youtube.com/embed/Yz4-G4TYpHc'
                    this.introVideoUrl1 = 'https://www.youtube.com/embed/ItbC9pkvzXo'
                    this.introVideoUrl2 = 'https://www.youtube.com/embed/xYPNLEYpw-s'
            }
        },
        // 获取中奖奖品列表
        getWinningList () {
            let params = {
                awardSource: 102,
                merchantId: this.pointsMeMerId,
                page: 1,
                size: 3
            }
            queryUserPrize(params).then(res => {
                if (Number(res.code) === 20000) {
                    if (!res.data) {
                        return
                    }
                    this.winningList = res.data.list.map(item => {
                        return {
                            id: item.id,
                            shopName: item.shopName,
                            activityAwardsName: item.activityAwardsName,
                            awardName: item.awardName,
                            receive: item.receive,
                            awardInvalidAt: this.formatValidTime(item.awardInvalidAt)
                        }
                    })
                    this.$nextTick(() => {
                        this.winningList.forEach((item, index) => {
                            this.createBarcode(item.id, index)
                        })
                    })
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
        // 格式化有效时间
        formatValidTime (val) {
            if (!val) return ''
            return this.$moment(val).format('DD/MM/YYYY')
        },
        // 初始化条形码
        createBarcode (code, i) {
            let barcodeOptions = {
                format: "CODE128",//条形码的格式
                width: 1,  //线宽
                height: 52,  //条码高度
                lineColor: '#3C3C43',//线条颜色
                displayValue: true,//是否显示文字
                fontSize: 12,//设置文本的大小
                margin: 5 //设置条形码周围的空白区域
            }
            JsBarcode("#lottery_win" + i, code, barcodeOptions)
        },
        // 获取平台抽奖码列表
        getLotteryCodeList () {
            // if (!this.activityId) return ''
            let params = {
                activityId: this.activityId,
                page: 1,
                size: 3
            }
            queryUserLottoCode(params).then(res => {
                if (Number(res.code) === 20000) {
                    if (!res.data) {
                        return
                    }
                    this.codeList = res.data.list
                    // status  101 未开始   102 进行中   103 已结束
                    // luckyDrawState   101 未开奖   102 未中奖   103 中奖
                    this.codeList.forEach(item => {
                        item.luckyDrawTime = this.formatLottoTime(item.activity.luckyDrawAt, item.activity.durationTime)
                        if (item.activity.status === 103) {
                            if (item.selected) {
                                item.luckyDrawState = 103
                            } else {
                                item.luckyDrawState = 102
                            }
                        } else {
                            item.luckyDrawState = 101
                        }
                    })
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
        // 格式化有效时间
        formatLottoTime (time, duration) {
            if (!time) return ''
            let startDate = this.$moment(time).format('DD/MM/YYYY')
            let startTime = this.$moment(time).format('HH:mm')
            let endDate = this.$moment(time).add(duration, 'hours').format('DD/MM/YYYY')
            let endTime = this.$moment(time).add(duration, 'hours').format('HH:mm')
            if (startDate === endDate) {
                return `${startDate} ${startTime}-${endTime}`
            } else {
                return `${startDate} ${startTime}-${endDate} ${endTime}`
            }
        },
        // 获取奖品列表
        getAwardsList () {
            let params = {
                merchantId: this.pointsMeMerId,
                device: 104
            }
            queryAwardsList(params).then(res => {
                if (Number(res.code) === 20000) {
                    if (!res.data) {
                        return
                    }
                    this.awardsList = res.data.groupItems || []
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
        // 当前播放项样式
        getPlayItemStyle (data) {
            return `width: ${data.lengthProportion}%; height: ${data.highProportion}%; left: ${data.lengthCoordinate}%; top: ${data.highCoordinate}%;`
        },
        // 下载
        downloadHandle1 () {
            // 判断手机系统
            let userAgent = navigator.userAgent
            if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
                window.location.href = `laidan://?code=${this.lotteryCode}`
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        this.$copyText(this.lotteryCode).then(
                            () => {
                                window.location.href = "https://apps.apple.com/cn/app/laidan/id1545081312";
                            },
                            () => {
                                window.location.href = "https://apps.apple.com/cn/app/laidan/id1545081312";
                            }
                        )
                    }
                }, 3000);
            } else if (userAgent.includes('Android')) {
                window.location.href = `laidan://?code=${this.lotteryCode}`
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        this.$copyText(this.lotteryCode).then(
                            () => {
                                window.location.href = "https://play.google.com/store/apps/details?id=com.pointsme.laidan";
                            },
                            () => {
                                window.location.href = "https://play.google.com/store/apps/details?id=com.pointsme.laidan";
                            }
                        )
                    }
                }, 2000);
            }
        },
        downloadHandle2 () {
            // 判断手机系统
            let userAgent = navigator.userAgent
            if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
                window.location.href = `laidan://`
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        window.location.href = "https://apps.apple.com/cn/app/laidan/id1545081312";
                    }
                }, 3000);
            } else if (userAgent.includes('Android')) {
                window.location.href = `laidan://`
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        window.location.href = "https://play.google.com/store/apps/details?id=com.pointsme.laidan";
                    }
                }, 2000);
            }
        }
    },
    // 创建完成
    created () {
    
    },
    // 挂载完成
    mounted () {
        // 语言
        this.language = localStorage.getItem('Language') || 'en'
        // 初始化数据
        this.initData()
        // 获取中奖奖品列表
        this.getWinningList()
        // 获取平台抽奖码列表
        this.getLotteryCodeList()
        // 获取奖品列表
        this.getAwardsList()
    },
    // 销毁之前
    beforeDestroy () {

    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    padding-top: 80px;
    background-color: #fafafa;
    .container-nav {
        position: fixed;
        width: 100%;
        height: 80px;
        left: 0;
        top: 0;
        z-index: 9;
        padding-left: 24px;
        padding-right: 24px;
        display: flex;
        align-items: center;
        background-color: #ffffff;
        img {
            height: 43px;
        }
    }
    .container-main {
        height: 100%;
        padding-bottom: 110px;
        overflow-y: auto;
        background: linear-gradient(180deg, rgba(236, 96, 42, 0.2) 0%, rgba(236, 138, 53, 0.2) 100%);
        .winning {
            margin-top: 24px;
            width: 100%;
            padding-left: 24px;
            .shell {
                width: 100%;
                height: 200px;
                position: relative;
                overflow: hidden;
                .list{
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    padding-right: 24px;
                    padding-bottom: 2px;
                    display: flex;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    .card{
                        width: 300px;
                        height: 200px;
                        padding: 12px 20px;
                        border-radius: 20px;
                        overflow: hidden;
                        flex-shrink: 0;
                        background-color: #FEFFFE;
                        box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);
                        margin-right: 12px;
                        display: flex;
                        flex-direction: column;
                        &:last-of-type {
                            margin-right: 0;
                        }
                        .card-header{
                            flex-shrink: 0;
                            .name{
                                font-size: 15px;
                                font-family: PingFang SC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #3C3C43;
                                line-height: 20px;
                            }
                            .date{
                                font-size: 10px;
                                font-family: PingFang SC-Semibold, PingFang SC;
                                color: rgba(60, 60, 67, 0.40);
                            }
                            .hint{
                                margin-top: 8px;
                                font-size: 10px;
                                font-family: PingFang SC-Semibold, PingFang SC;
                                color: #EE8D35;
                            }
                        }
                        .qrcode{
                            flex-grow: 1;
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }
            }
        }
        .code {
            margin-top: 24px;
            width: 100%;
            padding-left: 24px;
            .code-title {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #202326;
                line-height: 22px;
            }
            .shell {
                margin-top: 8px;
                width: 100%;
                height: 90px;
                position: relative;
                overflow: hidden;
                .list{
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    padding-right: 24px;
                    padding-bottom: 2px;
                    display: flex;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    .card{
                        width: 300px;
                        height: 90px;
                        padding: 12px 20px;
                        border-radius: 20px;
                        overflow: hidden;
                        flex-shrink: 0;
                        background-color: #FEFFFE;
                        box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);
                        margin-right: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        position: relative;
                        &:last-of-type {
                            margin-right: 0;
                        }
                        .title{
                            font-size: 15px;
                            font-family: PingFang SC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #3C3C43;
                        }
                        .text{
                            font-size: 12px;
                            font-family: PingFang SC-Semibold, PingFang SC;
                            color: #EE8D35;
                        }
                        .seal{
                            position: absolute;
                            right: 8px;
                            top: 5px;
                            width: 80px;
                            height: 80px;
                            background-image: url("../assets/images/seal.png");
                            background-size: 100% 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            .state{
                                text-align: center;
                                font-size: 10px;
                                font-family: PingFang SC-Semibold, PingFang SC;
                                color: #EE8D35;
                                transform: rotate(-18deg);
                            }
                        }
                    }
                }
            }
        }
        .flow {
            margin-top: 16px;
            width: 100%;
            height: 210px;
            .card {
                width: 100%;
                height: 100%;
                overflow: hidden;
                position: relative;
            }
        }
        .awards {
            margin-top: 16px;
            width: 100%;
            .awards-title {
                padding-left: 25px;
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #202326;
                line-height: 22px;
            }
            .card {
                margin-top: 15px;
                width: 100%;
                height: 240px;
                padding: 10px;
                background: #ffffff;
                border-radius: 8px;
                box-shadow: 1px 4px 7px 0px rgba(32, 32, 32, 0.05);
                overflow: hidden;
                position: relative;
                .play-item {
                    position: absolute;
                    overflow: hidden;
                    z-index: 2022;

                    i {
                        position: absolute;
                        bottom: 30px;
                        left: 20px;
                        font-size: 24px;
                        color: #ffffff;
                    }
                }
            }
        }
        .intro {
            margin-top: 16px;
            width: 100%;
            padding-left: 25px;
            //padding-right: 25px;
            .intro-title {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #202326;
                line-height: 22px;
            }
            .card {
                margin-top: 15px;
                width: 100%;
                height: 170px;
                position: relative;
                overflow: hidden;
                .list {
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    padding-right: 25px;
                    padding-bottom: 2px;
                    display: flex;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    .video {
                        width: 300px;
                        height: 170px;
                        border-radius: 6px;
                        overflow: hidden;
                        flex-shrink: 0;
                        margin-right: 12px;
                        &:last-of-type {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
        .rule {
            margin-top: 20px;
            width: 100%;
            padding-left: 25px;
            padding-right: 25px;
            .rule-title {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #fe6620;
                line-height: 20px;
            }
            .rule-content {
                margin-top: 20px;
                .rule-title{
                    font-size: 18px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #202326;
                    line-height: 20px;
                    text-align: center;
                }
                .rule-list{
                    padding-top: 10px;
                    .list-item{
                        margin-top: 20px;
                        .item-title{
                            font-size: 16px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #202326;
                            line-height: 20px;
                        }
                        .item-text{
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #8C8C8C;
                            line-height: 20px;
                            .label{
                                font-weight: 600;
                                color: #202326;
                            }
                            .dot{
                                display: inline-block;
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                                background-color: #8C8C8C;
                                margin-left: 3px;
                                margin-right: 3px;
                            }
                        }
                    }
                }
            }
        }
    }
    .download-handle {
        position: fixed;
        bottom: 50px;
        left: 0;
        right: 0;
        padding-left: 68px;
        padding-right: 68px;
        button {
            width: 100%;
            height: 44px;
            background: #fdd176;
            border-radius: 20px;
            border: none;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #202326;
            line-height: 20px;
        }
    }
}
</style>

